<template>
  <div class="flex min-h-screen justify-center items-center px-6 py-12 lg:px-8 bg-gradient-to-br from-red-600 to-indigo-600">
    <div class="bg-white p-12 rounded-xl box">
    <div class="sm:mx-auto sm:w-full sm:max-w-sm">
      <a href="https://www.lumbredocs.com.ar" target="_blank" rel="noopener noreferrer">
        <img class="mx-auto lg:h-10 " src="@/assets/images/logo-lumbredocs-black.png" alt="Logo" />
      </a>
      <h2 class="mt-9 text-center text-2xl font-bold leading-9 tracking-tight text-gray-800">Start a 14 day free trial</h2>
    </div>
    <div v-if="!loading" class="mt-3 sm:mx-auto sm:w-full sm:max-w-sm">
      <form class="space-y-2" @submit.prevent="onSubmit">
        <div>
          <label for="name" class="block text-sm font-semibold leading-6 text-gray-800">Nombre del cliente</label>
          <div>
            <input
              id="name"
              name="name"
              type="input"
              v-model.lazy="$v.form.name.$model"
              :class="{ 'error': $v.form.name.$error }"
              required
              tabindex="1"
              class="block w-full rounded-md border-gray-800 py-1.5 text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-100 sm:text-sm sm:leading-6 pl-2">
          </div>
        </div>
        <div>
          <label for="name" class="block text-sm font-semibold leading-6 text-gray-800">Nombre</label>
          <div>
            <input
              id="firstname"
              name="firstname"
              type="input"
              v-model.lazy="$v.form.firstname.$model"
              :class="{ 'error': $v.form.name.$error }"
              required
              tabindex="2"
              class="block w-full rounded-md border-gray-800 py-1.5 text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-100 sm:text-sm sm:leading-6 pl-2">
          </div>
        </div>

        <div>
          <label for="lastname" class="block text-sm font-semibold leading-6 text-gray-800">Apellido</label>
          <div>
            <input
              id="lastname"
              name="lastname"
              v-model.lazy="$v.form.lastname.$model"
              :class="{ 'error': $v.form.lastname.$error }"
              type="lastname"
              required
              tabindex="3"
              class="block w-full rounded-md border-gray-800 py-1.5 text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-100 sm:text-sm sm:leading-6 pl-2">
          </div>
        </div>

        <div>
          <label for="email" class="block text-sm font-semibold leading-6 text-gray-800">Email</label>
          <div>
            <input
              id="email"
              name="email"
              type="email"
              v-model.lazy="$v.form.email.$model"
              :class="{ 'error': $v.form.email.$error }"
              required
              tabindex="4"
              class="block w-full rounded-md border-gray-800 py-1.5 text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-100 sm:text-sm sm:leading-6 pl-2">
          </div>
        </div>

        <div>
          <label for="email" class="block text-sm font-semibold leading-6 text-gray-800">Contraseña</label>
          <div class="position-relative">
            <input
              id="password"
              name="password"
              :type="showInputValue ? 'text' : 'password'"
              v-model="form.password"
              required
              tabindex="5"
              :class="{ 'error': $v.form.password.$error }"
              @input="evaluatePassword"
              class="block w-full rounded-md  py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-100 sm:text-sm sm:leading-6 pl-2">
              <font-awesome-icon
                id="font-awesome-icon-eye"
                v-if="!showInputValue"
                icon="eye"
                size="sm"
                class="clickable eyes"
                @click="showInputValue = true"
                />
              <font-awesome-icon
                id="font-awesome-icon-eye-slash"
                v-if="showInputValue"
                icon="eye-slash"
                size="sm"
                class="clickable eyes"
                @click="showInputValue = false"
                />
              </div>
        </div>

        <div class="border border-gray-500 p-3 mt-3 rounded shadow" v-if="passwordStrength">
        <div>Fortaleza de la contraseña: <strong>{{ passwordScoreText }}</strong></div>
          <div v-if="passwordStrength && passwordStrength.feedback.suggestions.length">
            <strong>Sugerencias:</strong>
            <ul class="suggestions">
              <li v-for="(suggestion,  index) in passwordStrength.feedback.suggestions" :key="`suggestion-${index}`">{{ suggestion }}</li>
            </ul>
          </div>
        </div>
        <div style="margin-top: 25px;">
          <button
            type="submit"
            :disabled="!validateAll"
            class="flex w-full justify-center rounded-md  px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            :class="{'bg-indigo-200': !validateAll, 'bg-indigo-600 hover:bg-indigo-500 ': validateAll}"
          >
              <span v-show="!loadingRecaptcha">
                Enviar
              </span>
              <span v-show="loadingRecaptcha">
                <i class="mdi mdi-loading lm-button-loading spin"></i>
              </span>
          </button>
          <div v-if="successMessage" class="text-green-600 mt-3 text-center p-3  bg-green-100">
            {{ successMessage }}
             <p>Se redirigirá a la página de <router-link to="/login" class="underline">login</router-link> en {{ formattedCountdown }} segundos</p>
          </div>
        </div>
      </form>

      <p class="mt-10 text-center text-sm text-indigo-800"></p>
      <a href="https://www.lumile.com.ar" target="_blank" rel="noopener noreferrer">
        <img class="mt-4 mx-auto h-5 w-auto" :src="logoLumileWhite" alt="Logo" style="filter: invert();">
      </a>
      <router-link to="/login" class=" flex justify-center mt-4 text-sm text-indigo-800 hover:text-indigo-600">Regresar al login</router-link>
    </div>
    <div v-else class="flex justify-center items-center">
      <LmComponentLoading />
    </div>
    </div>
  </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
// import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmPassword from '@/components/form/elements/LmPassword'
// import store from '@/store'
import { mapState } from 'vuex'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
// import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'

import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core'
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common'
import * as zxcvbnEsEsPackage from '@zxcvbn-ts/language-es-es'
import commonsApi from '@/api/commons'
// import { generateRoutes } from '@/helpers/LmDynamicRoutes'

export default {
  name: 'Trial',
  inject: ['lumbredocs_v3'],
  components: {
    LmTextInput,
    LmPassword,
    // LmTreeSelect,
    LmButton
  },
  mixins: [lmToasts],
  data () {
    return {
      showInputValue: false,
      passwordStrength: null,
      timer: 5,
      interval: null,
      form: {
        name: null,
        firstname: null,
        lastname: null,
        email: '',
        password: null
      },
      serverErrorMessage: '',
      loading: false,
      loadingRecaptcha: false,
      successMessage: '',
      sentRestoreEmailSuccessfully: false,
      forgotPasswordMode: false,
      enableForgotPassword: process.env?.VUE_APP_ENABLE_FORGOT_PASSWORD === 'yes',
      errorUserOrPassword: false,
      isOnMesaContext: process.env?.VUE_APP_LUMBREDOCS_V3_MESA === 'yes'
    }
  },
  validations: {
    form: {
      email: {
        required: requiredIf(function (val) {
          return this.loginByEmail && val
        }),
        email
      },
      name: {
        required
      },
      firstname: {
        required
      },
      lastname: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    async recaptcha () {
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      const token = await this.$recaptcha('login')
      return token
    },
    async onSubmit () {
      try {
        if (this.passwordScoreText !== 'Débil') {
          if (this.isRecaptchaRequired) {
            await this.$recaptchaLoaded()
            const token = await this.$recaptcha('login')
            this.form.captcha = token
          }
          this.loadingRecaptcha = true
          const response = await commonsApi.axiosPostWrapper('/customer/newtrial', this.form)
          console.log('response:', response)
          if (response.status === 200) {
            this.successMessage = 'Se registró correctamente'
            setTimeout(() => {
              this.$router.push('/login')
            }, (this.timer * 1000))
          }
          this.startCountdown()
        }
      } catch (err) {
        console.log('err:', err)
      } finally {
        this.loadingRecaptcha = false
      }
    },
    evaluatePassword (el) {
      this.passwordStrength = zxcvbn(this.form.password)
    },
    startCountdown () {
      this.interval = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        } else {
          clearInterval(this.interval)
        }
      }, 1000)
    }
  },
  computed: {
    ...mapState('settings', ['logoLumileWhite']),
    isRecaptchaRequired () {
      return process.env.VUE_APP_IS_RECAPTCHA_REQUIRED === 'yes'
    },
    passwordScoreText () {
      let scoreText
      if (this.passwordStrength?.score >= this.minPasswordScore) {
        scoreText = 'Fuerte'
      } else if (this.passwordStrength?.score === 0 || this.passwordStrength?.score === undefined) {
        scoreText = 'Débil'
      } else {
        scoreText = 'Media'
      }
      return scoreText
    },
    validateAll () {
      return !this.$v.form.$invalid && this.passwordScoreText !== 'Débil'
    },
    formattedCountdown () {
      return this.timer > 0 ? this.timer : '0'
    }
  },
  mounted () {
    const options = {
      translations: zxcvbnEsEsPackage.translations,
      graphs: zxcvbnCommonPackage.adjacencyGraphs,
      dictionary: {
        ...zxcvbnCommonPackage.dictionary,
        ...zxcvbnEsEsPackage.dictionary
      }
    }
    zxcvbnOptions.setOptions(options)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  }
}
</script>
<style scoped>
.eyes{
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 1;
  }
input{
  border: 1px solid rgba(152, 166, 173, 0.5);
}
.spin {
  font-size: 1em;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}
.suggestions{
  list-style-type: none;
  display: initial;
  padding: 0;
  margin: 0;
}
.suggestions li{
  max-width: 100%;
  padding: 0;
  margin: 0;
}
.box{
  width: 430px;
}
</style>
